module.exports = __webpack_public_path__ + "static/media/R.fad05c82.svg";